
// DBASE >> @/menus/:uId/:selectedStartDate = {
//       dateOfPlanning: {
//           display: 'Sun, Jun 14, 2026',
//           value: '2026-06-14',
//       },
//       selectedStartDate: { display, value },
//       selectedWeekDays: [ {display,value}, ... ],
//       menu: [
//         {
//           date = {
//             display = 'Sun, 6/14',
//             value = '2026-06-14',
//           },
//           meals = {
//             meal1: '...',
//             meal2, meal3, meal4, meal5, meal6,
//           },
//         }, ...
//       ]
// }


/** HELPERS */
export function getShortDateDisplay(date) {
  const options = { weekday: 'short', month: 'short', day: 'numeric' };
  return date.toLocaleDateString('en-US', options); // e.g. "Sun, Jun 14"
}

export function getDateValue(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** DATES */
export function getDateOfPlanning() {
  // display -- e.g. "Fri, Jun 19, 2026"
  const now = new Date();
  const dateOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  };
  const display = now.toLocaleDateString('en-US', dateOptions);

  // value -- e.g. "2026-06-19"
  const yearStr = now.getFullYear();
  const monthStr = String(now.getMonth() + 1).padStart(2, '0');
  const dayStr = String(now.getDate()).padStart(2, '0');
  const value = `${yearStr}-${monthStr}-${dayStr}`;

  return {
    display,
    value,
  };
}

export function getPossibleStartDates() {
  const now = new Date();

  // Get most recent Sunday (or today if Sunday)
  const mostRecentSunday = new Date(now);
  mostRecentSunday.setDate(now.getDate() - now.getDay());

  const dates = [];
  let current = new Date(mostRecentSunday);

  for (let i = 0; i < 3; i++) {
    dates.push({
      display: getShortDateDisplay(current),
      value: getDateValue(current)
    });
    current.setDate(current.getDate() + 7);
  }

  return dates;
}



/** MENU CRUD */
// CREATE ONE NEW MENU
export async function createOneMenu(uId, token, menu, cheatMeals) {
  // this function RETURNS the newly created Menu's id, or throws an error

  const sSD = menu.selectedStartDate;
  console.log('*** MenuMakerServices.createOneMenu(menu) ***', sSD, menu);


  // create new menu object -- what will be saved in rtdb
  const newMenu = {
    datOfPlanning: menu.dateOfPlanning,
    menu: menu.menu,
    selectedWeekDays: menu.selectedWeekDays,
  };
  console.log('*** createOneMenu() >> newMenu ***', newMenu)

  // API - CREATE NEW MENU IN DBASE
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/menus/${uId}/${sSD}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(newMenu),
  });

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MenuMakerServices >> Failed to create new Menu');
  }

  // no error, i.e. successful save
  const responseData = await response.json();
  console.log('*** MenuMakerServices >> responseData ***', responseData);


  // figure out which cheatMeals to delete
  if (cheatMeals && menu.scheduledCheatMealIds) {

    // allMeals (unique)
    const set = new Set();
    menu.menu?.forEach(day => {
      Object.values(day.meals || {}).forEach(meal => {
        if (meal && meal.trim()) set.add(meal.trim());
      });
    });
    const allScheduledMeals = Array.from(set);

    // these cheat meals exist in allMeals
    let confirmedDeleteTheseCheatMeals = {};
    for (let id of Object.keys(cheatMeals)) {
      const cm = cheatMeals[id].craving;
      for (let meal of allScheduledMeals) {
        if (meal && meal.includes(cm)) {
          confirmedDeleteTheseCheatMeals[`/${id}`] = null;
        }
      }
    }
    await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/cheatmeals.json?auth=${token}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(confirmedDeleteTheseCheatMeals)
    });

  }



  return responseData;
}



// READ ALL MENUS (SHALLOW - just the existing menuStartDates)
export async function readAllMenusDates(uId, token) {
  // console.log('*** readAllMenusDates() ***', uId, token);

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/menus/${uId}.json?auth=${token}&shallow=true`);
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to get all existing Menus');
  }
  return responseData;

}



// READ ONE MENU
export async function readOneMenu(uId, token, menuStartDate) {
  console.log('*** readOneMenu(menuStartDate) ***', menuStartDate);

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/menus/${uId}/${menuStartDate}.json?auth=${token}`);


  // response
  if (!response.ok) {
    console.log('*** err ***', response);
    throw new Error(response.message || 'Failed to get one Menu');
  }

  // let menu = null;
  const responseData = await response.json();

  // if (responseData) {
  //   menu = responseData;
  // }
  // return menu;

  return responseData;
}



// UPDATE ONE SINGLE MEAL IN MENU
export async function updateOneSingleMealInMenu(uId, token, menuDate, mealDay, mealNum, mealText) {
  console.log('*** MindMovieServices >> updateOneSingleMealInMenu(menuDate, mealDay, mealNum, mealText) ***', menuDate, mealDay, mealNum, mealText);

  console.log('*** api endpoint ***', `/menus/${uId}/${menuDate}/menu/${mealDay}/meals/${mealNum}`);
  // API call to dbase
  let updatedMeal = {};
  updatedMeal[mealNum] = mealText;
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/menus/${uId}/${menuDate}/menu/${mealDay}/meals.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(updatedMeal),
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to update a MindMovie Category');
  }

  // return data
  return responseData;
}



// DELETE ONE MENU
export async function deleteOneMenu(uId, token, menuStartDate) {
  console.log('*** MenuMakerServices >> deleteOneMenu(menuStartDate) ***', menuStartDate);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/menus/${uId}/${menuStartDate}.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MenuMakerServices >> Failed to delete a Menu');
  }

  return responseData;
}
